import React from 'react';
import { StarIcon } from 'lucide-react';
type SectionDividerProps = {
  /** Match the background of the section that follows. */
  tone: 'light' | 'dark';
};

/** Thin gold rule with a single small star — used consistently between major sections. */
export function SectionDivider({
  tone
}: SectionDividerProps) {
  return <div aria-hidden="true" className={`${tone === 'light' ? 'bg-paper' : 'bg-navy'} pt-14 md:pt-16`} data-id="element-150" data-mp="3946g20bno1i8">
      <div className="mx-auto flex max-w-xs items-center gap-4 px-6" data-id="element-151" data-mp="346n10y74vkp8">
        <span className="h-px flex-1 bg-gold/70" data-id="element-152" data-mp="2zewp4nsjsovp" />
        <StarIcon className="h-3.5 w-3.5 fill-gold text-gold" strokeWidth={1} data-id="element-153" data-mp="2zd21v2tt0kog" />
        <span className="h-px flex-1 bg-gold/70" data-id="element-154" data-mp="2ugle49qio8bw" />
      </div>
    </div>;
}